/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DocCertIcon16Light } from './DocCertIcon16Light';
import { DocCertIcon16Regular } from './DocCertIcon16Regular';
import { DocCertIcon16Solid } from './DocCertIcon16Solid';
import { DocCertIcon20Light } from './DocCertIcon20Light';
import { DocCertIcon20Regular } from './DocCertIcon20Regular';
import { DocCertIcon20Solid } from './DocCertIcon20Solid';
import { DocCertIcon24Regular } from './DocCertIcon24Regular';
import { DocCertIcon24Solid } from './DocCertIcon24Solid';
import { DocCertIcon32Regular } from './DocCertIcon32Regular';
import { DocCertIcon64Regular } from './DocCertIcon64Regular';
var sizes = {
    16: {
        light: DocCertIcon16Light,
        regular: DocCertIcon16Regular,
        solid: DocCertIcon16Solid,
    },
    20: {
        light: DocCertIcon20Light,
        regular: DocCertIcon20Regular,
        solid: DocCertIcon20Solid,
    },
    24: {
        regular: DocCertIcon24Regular,
        solid: DocCertIcon24Solid,
    },
    32: {
        regular: DocCertIcon32Regular,
    },
    64: {
        regular: DocCertIcon64Regular,
    },
};
export var DocCertIcon = forwardRef('DocCertIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
